import { useEffect, useState } from 'react';
import Api from 'api';

/** Office -> Talent relationship. A saved-office heart is the reverse fact
 * and must never authorize Instant Book. Results belong to one actor/location. */
export function useOfficeFavourite(hygienistId: number, locationId: number, refresh = 0): boolean {
    const actor = Number(hygienistId);
    const office = Number(locationId);
    const key = `${actor}:${office}:${refresh}`;
    const [result, setResult] = useState<{ key: string; favourite: boolean } | null>(null);

    useEffect(() => {
        let cancelled = false;
        if (!Number.isSafeInteger(actor) || actor <= 0 || !Number.isSafeInteger(office) || office <= 0) {
            return;
        }
        Api.checkFavouriteHygienistLocations([office]).then(response => {
            const ids: unknown = response?.isFavouriteHygienist;
            const validIds = Array.isArray(ids) && ids.every(id => (
                (typeof id === 'number' || (typeof id === 'string' && /^\d+$/.test(id)))
                && Number.isSafeInteger(Number(id)) && Number(id) > 0
            ));
            if (!cancelled) setResult({ key, favourite: validIds && (ids as Array<number | string>).some(id => Number(id) === office) });
        }).catch(() => {
            if (!cancelled) setResult({ key, favourite: false });
        });
        return () => { cancelled = true; };
    }, [actor, office, key]);

    // Invalidate synchronously on identity/refresh changes, before effects run.
    return result?.key === key && result.favourite;
}
